import React from 'react';

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '2.9em', height: '2.9em' }}>
        <path d="M4 3H20C20.5523 3 21 3.44772 21 4V15C21 15.5523 20.5523 16 20 16H10L7 19V16H4C3.44772 16 3 15.5523 3 15V4C3 3.44772 3.44772 3 4 3Z"></path>
      </svg>
    ),
    title: 'Real-Time, Adaptive Dialogue',
    desc: 'AI-powered patients that respond naturally to questions and provide emotionally intelligent feedback.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '2.9em', height: '2.9em' }}>
        <path d="M12 3C8.5 3 5 5.5 5 9C5 11.5 6.5 13.5 8.5 15S12 18 12 21C12 18 15.5 16 17.5 15S19 11.5 19 9C19 5.5 15.5 3 12 3Z"></path>
        <path d="M12 3V8M9 6C8 8.5 8 12 9 14.5M15 6C16 8.5 16 12 15 14.5"></path>
      </svg>
    ),
    title: 'Virtual Diagnostic Tools',
    desc: 'Comprehensive suite of virtual diagnostic tools to practice clinical reasoning in a safe environment.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '2.9em', height: '2.9em' }}>
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M12 7V12L15.5 14"></path>
      </svg>
    ),
    title: 'Anytime, Anywhere Access',
    desc: 'Cloud-based platform accessible 24/7 from any device, enabling flexible learning schedules.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '2.9em', height: '2.9em' }}>
        <line x1="5" y1="20" x2="19" y2="20"></line>
        <rect x="6" y="12" width="2.5" height="8" rx="1"></rect>
        <rect x="10.75" y="6" width="2.5" height="14" rx="1"></rect>
        <rect x="15.5" y="15" width="2.5" height="5" rx="1"></rect>
      </svg>
    ),
    title: 'Data-Driven Feedback',
    desc: 'Detailed analytics on performance, communication skills, and clinical decision-making.'
  }
];

const SolutionSection: React.FC = () => (
  <section id="solution" style={{ background: '#fff', padding: '4rem 0', textAlign: 'center' }}>
    <h2 style={{ fontSize: '2.5rem', fontWeight: 800, marginBottom: '1rem', '@media (max-width: 768px)': { fontSize: '2rem' } }}>
      The Solution: SILO AI Patient Simulations
    </h2>
    <p style={{ color: '#666', fontSize: '1.25rem', marginBottom: '3rem', maxWidth: '900px', margin: '0 auto 3rem auto', '@media (max-width: 768px)': { fontSize: '1.05rem', marginBottom: '2rem' } }}>
      Our platform provides comprehensive, adaptive training that scales across medical curricula.
    </p>
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      gap: '2.5rem',
      flexWrap: 'nowrap',
      maxWidth: 1400,
      margin: '0 auto',
      padding: '0 1rem',
      overflowX: 'auto',
      '@media (max-width: 1200px)': {
        gap: '1.5rem',
        padding: '0 0.5rem',
      },
      '@media (max-width: 900px)': {
        gap: '1rem',
        padding: '0 0.25rem',
      }
    }}>
      {features.map((f, i) => (
        <div key={i} style={{
          flex: '0 0 220px',
          minWidth: 180,
          maxWidth: 220,
          height: 210,
          background: '#f6fcfc',
          border: '1px solid #b2dfdb33',
          borderRadius: 16,
          padding: '2rem 1rem',
          boxShadow: '0 2px 12px rgba(0,0,0,0.03)',
          textAlign: 'left',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          '@media (max-width: 768px)': {
            minWidth: 140,
            maxWidth: 180,
            height: 170,
            padding: '1.25rem 0.5rem',
          }
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            marginBottom: '1rem', 
            color: '#223A5E',
            height: '3.5em',
            '@media (min-width: 768px)': {
              height: '4em'
            }
          }}>{f.icon}</div>
          <div style={{ 
            fontWeight: 700, 
            fontSize: '1.35rem', 
            marginBottom: '0.5rem',
            textAlign: 'center',
            '@media (min-width: 768px)': {
              fontSize: '1.5rem'
            },
            '@media (max-width: 768px)': {
              fontSize: '1.15rem'
            }
          }}>{f.title}</div>
          <div style={{ 
            color: '#555', 
            fontSize: '1.1rem',
            textAlign: 'center',
            '@media (min-width: 768px)': {
              fontSize: '1.2rem'
            },
            '@media (max-width: 768px)': {
              fontSize: '1rem'
            }
          }}>{f.desc}</div>
        </div>
      ))}
    </div>
  </section>
);

export default SolutionSection; 